import { StateCreator } from "zustand";
export interface AppSlice {
  lang: string;
  name: string;
  description: string;
  categoryId: number;
  langOpenBottomSheet: boolean;
  displayWaygrid: boolean;
  changeCategory: (id: number) => void;
  changeLangBottomSheet: (value: boolean) => void;
  changeDisplayWaygrid: (value: boolean) => void;
  changeLang: (lang: string) => void;
}

export const createAppSlice: StateCreator<AppSlice, []> = (set) => ({
  lang: "",
  name: "",
  description: "",
  categoryId: 0,
  langOpenBottomSheet: false,
  displayWaygrid: true,
  
  changeLang: (lang) => {
    localStorage.setItem("Lang", lang);
    set((state) => ({
      ...state,
      lang: lang,
      name: lang === "ar" ? "name_ar" : "name_en",
      description: lang === "ar" ? "description_ar" : "description_en",
    }));
  },
  changeCategory: (id) => {
    set((state) => ({ ...state, categoryId: id }));
  },
  changeLangBottomSheet: (value) => {
    set((state) => ({ ...state, langOpenBottomSheet: value }));
  },
  changeDisplayWaygrid: (value) => {
    set((state) => ({ ...state, displayWaygrid: value }));
  },
});
